import { Tooltip } from '@/components/ui/Tooltip';

/** "Antes" acumula la cola de anteriores por orden, sin importar si el admin ya las aprobó. Cuando
 * eso difiere de lo oficial (lo que el admin ya confirmó), se antepone ese valor a la cadena
 * antes→después — así queda visible de una que "antes" todavía depende de asesorías sin aprobar,
 * en vez de un ícono con tooltip que hay que pasar el mouse para descubrir. */
export function OficialPrefix({ oficial, proyectado, format }: { oficial?: number; proyectado: number; format: (n: number) => string }) {
  if (oficial == null || Math.round(oficial * 10) === Math.round(proyectado * 10)) return null;
  return (
    <>
      <Tooltip label="Último valor oficial confirmado por el admin">
        <span className="text-gray-300 text-[10px]">{format(oficial)}</span>
      </Tooltip>
      <span className="text-gray-300 text-[10px]">→</span>
    </>
  );
}
